module.exports = {"title":"1:1 Inquiry","replyStatus":"Reply Status","answered":"Answered","checking":"In Review","registerReply":"Register Reply","editReply":"Edit","typeService":"Service","typeEvent":"Event","typeUpdate":"Update"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cs102.json
// module id = wXzO
// module chunks = 2